import { useMemo } from 'react';
import { useIsTerminalMode } from 'hooks/useIsTerminalMode';
import { UserPanelTerminalViewSkeleton } from './views/Terminal/Skeleton';
import { UserPanelWebViewSkeleton } from './views/Web/Skeleton';

export enum EScreenType {
  WEB = 'web',
  TERMINAL = 'terminal'
}

const VIEWS = {
  [EScreenType.WEB]: UserPanelWebViewSkeleton,
  [EScreenType.TERMINAL]: UserPanelTerminalViewSkeleton
};

export const UserPanelSkeleton = () => {
  const { isTerminalMode } = useIsTerminalMode();
  const screenType = isTerminalMode ? EScreenType.TERMINAL : EScreenType.WEB;
  const View = useMemo(() => VIEWS[screenType], [screenType]);

  return <View />;
};
